/* Metabar Wise — global helpers (wishlist, cart, reveal, counters) */
(function () {
  const MW = (window.MW = window.MW || {});
  const store = {
    get(key, fallback) {
      try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
    },
    set(key, val) {
      try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* storage unavailable */ }
    },
  };
  MW.store = store;

  /* ---------- money ---------- */
  MW.formatMoney = function (cents, format) {
    format = format || MW.moneyFormat || '{{amount}} ₺';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    const fmt = (n, dec, t, d) => {
      const parts = (n / 100).toFixed(dec).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  };

  /* ---------- turkish-safe handleize ---------- */
  MW.slug = function (s) {
    return String(s || '')
      .toLocaleLowerCase('tr')
      .replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ş/g, 's').replace(/ü/g, 'u')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  };

  /* ---------- wishlist ---------- */
  const WKEY = 'mw-wishlist';
  MW.wishlist = {
    all() { return store.get(WKEY, []); },
    has(h) { return this.all().indexOf(h) > -1; },
    toggle(h) {
      let list = this.all();
      const on = list.indexOf(h) === -1;
      list = on ? [h].concat(list) : list.filter((x) => x !== h);
      store.set(WKEY, list.slice(0, 60));
      document.dispatchEvent(new CustomEvent('mw:wishlist', { detail: { handle: h, on } }));
      return on;
    },
    remove(h) { store.set(WKEY, this.all().filter((x) => x !== h)); document.dispatchEvent(new CustomEvent('mw:wishlist', { detail: { handle: h, on: false } })); },
  };
  function syncWish() {
    const list = MW.wishlist.all();
    document.querySelectorAll('[data-mw-wish]').forEach((btn) => {
      const on = list.indexOf(btn.dataset.mwWish) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-mw-wish-count]').forEach((el) => {
      el.textContent = list.length;
      el.dataset.count = list.length;
    });
  }
  MW.syncWish = syncWish;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mw-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    MW.wishlist.toggle(btn.dataset.mwWish);
    btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop');
  });
  document.addEventListener('mw:wishlist', syncWish);

  /* ---------- cart ---------- */
  MW.addToCart = async function (variantId, qty, btn) {
    if (!variantId) return;
    const drawer = document.querySelector('cart-drawer');
    const notification = document.querySelector('cart-notification');
    const cart = drawer || notification;
    if (btn) btn.classList.add('is-loading');
    try {
      const fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', qty || 1);
      if (cart) {
        fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
        fd.append('sections_url', window.location.pathname);
        cart.setActiveElement && cart.setActiveElement(document.activeElement);
      }
      const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd,
      });
      const data = await res.json();
      if (data.status) { alert(data.description || data.message); return; }
      if (cart) {
        cart.classList.contains('is-empty') && cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      if (window.publish && typeof PUB_SUB_EVENTS !== 'undefined') window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mw', productVariantId: variantId, cartData: data });
      else MW.refreshCartCount();
    } catch (err) {
      console.error(err);
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mw-add]');
    if (!b) return;
    e.preventDefault();
    MW.addToCart(b.dataset.mwAdd, parseInt(b.dataset.qty || '1', 10), b);
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mw-open-cart]');
    if (!b) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer) { e.preventDefault(); drawer.open(); }
  });

  /* ---------- protein target ---------- */
  MW.goals = {
    bariatrik: { f: 1.1, min: 60, max: 90, label: 'Yüksek protein' },
    kilo: { f: 1.2, min: 50, max: 160, label: 'Kalori kontrolü' },
    spor: { f: 1.6, min: 60, max: 200, label: 'Aktif spor / kas' },
    genel: { f: 0.8, min: 40, max: 140, label: 'Genel sağlıklı beslenme' },
  };
  MW.proteinTarget = function (kg, goal) {
    const g = MW.goals[goal] || MW.goals.genel;
    kg = parseFloat(kg) || 0;
    if (!kg) return 0;
    return Math.round(Math.min(g.max, Math.max(g.min, kg * g.f)));
  };

  /* ---------- reveal + counters ---------- */
  function countUp(el) {
    const to = parseFloat(String(el.dataset.mwCountTo).replace(',', '.'));
    const dec = (String(el.dataset.mwCountTo).split(/[.,]/)[1] || '').length;
    const dur = 1400; const t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const v = to * (1 - Math.pow(1 - p, 3));
      el.textContent = v.toFixed(dec).replace('.', ',');
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  function initReveal(root) {
    const els = (root || document).querySelectorAll('.mw-reveal:not(.is-in), [data-mw-count-to]:not(.is-counted)');
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const el = en.target;
        if (el.dataset.mwCountTo) { el.classList.add('is-counted'); countUp(el); } else el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  }
  MW.initReveal = initReveal;

  MW.refreshCartCount = function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => {
      document.querySelectorAll('[data-mw-cart-count]').forEach((el) => { el.textContent = c.item_count; el.dataset.count = c.item_count; });
      document.dispatchEvent(new CustomEvent('mw:cart', { detail: c }));
    }).catch(() => {});
  };
  function boot() {
    syncWish(); initReveal();
    if (window.subscribe && typeof PUB_SUB_EVENTS !== 'undefined') window.subscribe(PUB_SUB_EVENTS.cartUpdate, () => MW.refreshCartCount());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { syncWish(); initReveal(e.target); });
})();

/* v6: urun detay sekmeleri duzenleyici (aciklamadaki tablo kopyasini kaldirir, etiket/not/hazirlama bilgisini dogru sekmeye tasir) */
(function () {
  function run() {
    document.querySelectorAll('[data-mw-pd]').forEach(function (r) {
      if (r.dataset.mwNorm) return;
      r.dataset.mwNorm = 1;
      var desc = r.querySelector('[data-p="desc"] .mw-pd__full');
      if (!desc) return;
      var aside = desc.querySelector('.mw-pd__nutrition-card');
      if (aside) aside.remove();
      desc.classList.remove('mw-pd__overview');
      var nut = r.querySelector('[data-p="nutrition"]');
      var use = r.querySelector('[data-p="use"]');
      var ps = Array.from(desc.querySelectorAll('p'));
      if (nut) {
        var labels = ps.filter(function (p) { return /^[^:.]{2,30}\s*:$/.test(p.textContent.trim()) && !p.querySelector('img') && !/^Sette/i.test(p.textContent.trim()); });
        var tables = Array.from(nut.children).filter(function (e) { return e.tagName === 'TABLE' || e.tagName === 'FIGURE'; });
        if (labels.length && labels.length === tables.length) {
          labels.forEach(function (l, i) {
            var h = document.createElement('h4');
            h.className = 'mw-pd__tlabel';
            h.textContent = l.textContent.replace(/\s*:\s*$/, '').trim();
            tables[i].before(h);
            l.remove();
          });
        }
        ps.forEach(function (p) {
          var t = p.textContent.trim();
          if (p.isConnected && /^(\*|Değerler analiz)/i.test(t) && /referans|\(RA\)|analiz|kcal/i.test(t)) nut.append(p);
        });
      }
      if (use) {
        var anchor = use.firstChild;
        ps.forEach(function (p) {
          var t = p.textContent.trim();
          if (p.isConnected && /hazırla(mak|ma)k? için|hazırlanışı/i.test(t) && t.length < 80) {
            var n = p.nextElementSibling;
            use.insertBefore(p, anchor);
            if (n && (n.tagName === 'OL' || n.tagName === 'UL')) use.insertBefore(n, anchor);
          }
        });
      }
      var det = desc.querySelector('.mw-pd__intro details');
      if (det) det.open = true;
            var intro = desc.querySelector('.mw-pd__intro');
      if (intro && det) desc.querySelectorAll('details p.mw-lead').forEach(function (p) { intro.insertBefore(p, det); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* v6: puan rozeti - yorum yoksa basligin altinda "ilk degerlendirme" cagrisi, tiklayinca yorumlara kayar */
(function () {
  function rate() {
    var w = document.getElementById('judgeme_product_reviews');
    var title = document.querySelector('.product__info-container .product__title');
    if (!w || !title || document.querySelector('.mw-rate-cta')) return;
    var badge = document.querySelector('.product__info-container .jdgm-prev-badge');
    var n = badge ? parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0 : 0;
    if (n > 0) return;
    var a = document.createElement('a');
    a.className = 'mw-rate-cta';
    a.href = '#judgeme_product_reviews';
    a.innerHTML = '<span class="mw-rate-stars" aria-hidden="true">☆☆☆☆☆</span><span class="mw-rate-txt">İlk değerlendirmeyi siz yazın</span>';
    a.addEventListener('click', function (e) { e.preventDefault(); w.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    var next = title.nextElementSibling;
    (next && next.querySelector('.jdgm-preview-badge') ? next : title).after(a);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rate); else rate();
})();
/* v6f: tablosuz urunlerde de ayni aciklama yapisi + uzun ozellik etiketlerini aciklamaya tasi */
(function () { var INFO = /^(Uyar|Tavsiye edilen|Menşe|\(|Net Miktar|Kullanım|Saklama|İçindekiler)/i; function run() { document.querySelectorAll('[data-mw-pd]').forEach(function (r) { if (r.dataset.mwNorm2) return; r.dataset.mwNorm2 = 1; var full = r.querySelector('[data-p="desc"] .mw-pd__full'); if (!full) return; var intro = full.querySelector('.mw-pd__intro'); if (!intro) { intro = document.createElement('div'); intro.className = 'mw-pd__intro'; var det = document.createElement('details'); var sum = document.createElement('summary'); sum.textContent = 'Ürün bilgileri ve uyarılar'; det.append(sum); Array.from(full.children).forEach(function (n) { var t = n.textContent.trim(); if (n.tagName === 'P' && (INFO.test(t) || n.querySelector('img'))) det.append(n); else if (t || n.querySelector('img')) intro.append(n); else n.remove(); }); full.append(intro); if (det.children.length > 1) { det.open = true; intro.append(det); } } var hl = document.querySelector('.product__info-container .mw-highlights'); if (hl) { var d2 = intro.querySelector(':scope > details'); Array.from(hl.children).forEach(function (li) { var t = li.textContent.trim().replace(/\s+/g, ' '); if (t.length > 85) { var p = document.createElement('p'); p.className = 'mw-lead'; p.textContent = t; if (d2) intro.insertBefore(p, d2); else intro.append(p); li.remove(); } }); } }); } if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run(); })();
/* v6g: setlerde bilesen secimi (tablet aromasi, corba cesidi) sepete satir ozelligi olarak gider */ (function () { var TAB = { k: 'Tablet aroması', t: 'Çiğneme tableti aroması', o: ['Kavun', 'Limon', 'Portakal'] }; var COR = { k: 'Çorba çeşidi', t: 'Proteinli çorba çeşidi', o: ['Mix', 'Mantar', 'Mercimek', 'Kremalı Tavuk'] }; var SH = ['Shaker'], MV = ['Multivitamin 60 kapsül', 'Shaker']; var CFG = { 'baslangic-seti-7': { s: "7'li", c: [TAB, COR], f: SH }, 'baslangic-seti-15': { s: "15'li", c: [TAB, COR], f: SH }, 'protein-vitamin-seti-7': { s: "7'li", c: [COR], f: MV }, 'protein-vitamin-seti-15': { s: "15'li", c: [COR], f: MV }, 'sase-corba-seti-7': { s: "7'li", c: [COR], f: SH }, 'sase-corba-seti-15': { s: "15'li", c: [COR], f: SH }, 'sase-corba-seti-30': { s: "30'lu", c: [COR], f: SH }, 'sase-multivitamin-seti-7': { s: "7'li", c: [], f: MV }, 'sase-multivitamin-seti-15': { s: "15'li", c: [], f: MV }, 'sase-multivitamin-seti-30': { s: "30'lu", c: [], f: MV }, 'protein-vitamin-seti': { s: '30\'lu', c: [COR], f: ['Multivitamin 60 kapsül', 'Shaker'] }, 'protein-vitamin-kolajen-seti': { s: '30\'lu', c: [TAB], f: ['Multivitamin 60 kapsül', 'Toz kolajen 30 servis'] }, 'baslangic-seti': { s: '30\'lu', c: [TAB, COR], f: ['Shaker'] }, 'metabar-wise-whey-protein-sase-30lu-kutu': { s: '30\'lu', c: [TAB], f: ['Shaker'] }, 'metabar-wise-whey-protein-sase-15li-kutu-cigneme-tableti-60-tablet': { s: '15\'li', c: [TAB], f: ['Shaker'] }, 'metabar-wise-whey-protein-sase-7li-kutu-cigneme-tableti-60-tablet': { s: '7\'li', c: [TAB], f: ['Shaker'] } }; var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1]; var cfg = h && CFG[decodeURIComponent(h)]; if (!cfg) return; var state = {}; cfg.c.forEach(function (c) { state[c.k] = c.o[0]; }); function slug(s) { return s.toLocaleLowerCase('tr').replace(/ı/g, 'i').replace(/ç/g, 'c').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/\s+/g, '-'); } function form() { return document.querySelector('form[id^="product-form-"]:not([id*="installment"])'); } function radios() { return Array.from(document.querySelectorAll('.product__info-container variant-selects input[type="radio"]')); } function setText(el, t) { if (el.textContent !== t) el.textContent = t; } function sync() { var f = form(); if (f) cfg.c.forEach(function (c) { var n = 'properties[' + c.k + ']'; var i = f.querySelector('input[name="' + n + '"]'); if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = n; f.appendChild(i); } if (i.value !== state[c.k]) i.value = state[c.k]; }); document.querySelectorAll('.mw-set-summary li').forEach(function (li) { if (!li.dataset.o) li.dataset.o = li.textContent; var t = li.dataset.o; if (state['Tablet aroması'] && /Tablet/i.test(t)) t = t + ' – ' + state['Tablet aroması']; if (state['Çorba çeşidi'] && /Çorba/i.test(t)) t = t.replace(/9.lu\s*Mix/i, '9\'lu ' + state['Çorba çeşidi']); setText(li, t); }); } function row(n, title, opts, cur, pick) { var d = document.createElement('div'); var l = document.createElement('p'); l.className = 'mw-siblings__label'; l.append(n + ' · ' + title + ' '); var b = document.createElement('b'); b.textContent = cur; l.append(b); d.append(l); var r = document.createElement('div'); r.className = 'mw-siblings__row'; opts.forEach(function (o) { var p = document.createElement('button'); p.type = 'button'; p.className = 'mw-pill mw-aroma--' + slug(o) + (o === cur ? ' is-current' : ''); p.append(document.createElement('i'), o); p.addEventListener('click', function () { pick(o); }); r.append(p); }); d.append(r); return d; } function render() { var vs = document.querySelector('.product__info-container variant-selects'); if (!vs) return; var box = document.querySelector('.mw-setpick'); if (!box) { box = document.createElement('div'); box.className = 'mw-siblings mw-setpick'; vs.before(box); } var rs = radios(); var cur = (rs.filter(function (x) { return x.checked; })[0] || {}).value || ''; var key = cur + '|' + cfg.c.map(function (c) { return state[c.k]; }).join('|'); if (box.dataset.k !== key) { box.dataset.k = key; box.textContent = ''; var hd = document.createElement('p'); hd.className = 'mw-setpick-hd'; hd.textContent = 'Setinizi oluşturun'; box.append(hd); box.append(row(1, 'Saşe aroması (' + cfg.s + ' kutu)', rs.map(function (x) { return x.value; }), cur, function (o) { var rr = radios().filter(function (x) { return x.value === o; })[0]; if (rr && !rr.checked) rr.click(); setTimeout(render, 60); setTimeout(render, 600); })); cfg.c.forEach(function (c, ci) { box.append(row(ci + 2, c.t, c.o, state[c.k], function (o) { state[c.k] = o; render(); })); }); if (cfg.f.length) { var p = document.createElement('p'); p.className = 'mw-setpick__inc'; p.textContent = 'Sette ayrıca: ' + cfg.f.join(' · '); box.append(p); } } sync(); } function init() { render(); var root = document.querySelector('.product__info-container') || document.body; new MutationObserver(function () { render(); }).observe(root, { childList: true, subtree: true }); document.addEventListener('submit', function (e) { if (e.target === form()) sync(); }, true); } if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init(); })();

/* v6i: set aciklamasinda set listesi ve avantaj satiri giris bolumune */
(function () {
  function run() {
    document.querySelectorAll('[data-mw-pd]').forEach(function (r) {
      if (r.dataset.mwNorm3) return;
      r.dataset.mwNorm3 = 1;
      var intro = r.querySelector('[data-p="desc"] .mw-pd__intro');
      var det = intro && intro.querySelector(':scope > details');
      if (!det) return;
      var sh = Array.from(det.querySelectorAll('p')).filter(function (p) { return /^Sette neler var\s*:/i.test(p.textContent.trim()); })[0];
      if (sh) {
        var ul = sh.nextElementSibling;
        intro.insertBefore(sh, det);
        if (ul && ul.tagName === 'UL') intro.insertBefore(ul, det);
      }
      Array.from(det.querySelectorAll('p')).forEach(function (p) {
        if (/^Ayrı ayrı alındığında/i.test(p.textContent.trim())) intro.insertBefore(p, det);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* v6j: setlerde paket boyutu (7'li / 15'li / 30'lu) secimi */
(function () {
  var G = [
    ['baslangic-seti-7', 'baslangic-seti-15', 'baslangic-seti'],
    ['protein-vitamin-seti-7', 'protein-vitamin-seti-15', 'protein-vitamin-seti'],
    ['metabar-wise-whey-protein-sase-7li-kutu-cigneme-tableti-60-tablet', 'metabar-wise-whey-protein-sase-15li-kutu-cigneme-tableti-60-tablet', 'metabar-wise-whey-protein-sase-30lu-kutu'],
    ['sase-corba-seti-7', 'sase-corba-seti-15', 'sase-corba-seti-30'],
    ['sase-multivitamin-seti-7', 'sase-multivitamin-seti-15', 'sase-multivitamin-seti-30']
  ];
  var L = ["7'li", "15'li", "30'lu"];
  var h = decodeURIComponent((location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '');
  var g = G.filter(function (x) { return x.indexOf(h) > -1; })[0];
  if (!g) return;
  var el = document.createElement('div');
  el.className = 'mw-setsize';
  var lab = document.createElement('p');
  lab.className = 'mw-siblings__label';
  lab.append('Paket boyutu ');
  var b = document.createElement('b');
  b.textContent = L[g.indexOf(h)] + ' saşe';
  lab.append(b);
  var row = document.createElement('div');
  row.className = 'mw-siblings__row';
  row.setAttribute('data-mw-sort', '');
  g.forEach(function (x, i) {
    var cur = x === h;
    var a = document.createElement(cur ? 'span' : 'a');
    a.className = 'mw-pill' + (cur ? ' is-current' : '');
    if (!cur) a.href = '/products/' + x;
    a.append(L[i] + ' saşe');
    var sm = document.createElement('small');
    a.append(sm);
    row.append(a);
    fetch('/products/' + x + '.js').then(function (r) { return r.json(); }).then(function (p) { sm.textContent = Math.round(p.price / 100).toLocaleString('tr-TR') + ' TL'; }).catch(function () {});
  });
  el.append(lab, row);
  function put() {
    var box = document.querySelector('.mw-setpick');
    if (!box || box.contains(el)) return;
    var hd = box.querySelector('.mw-setpick-hd');
    if (hd) hd.after(el); else box.prepend(el);
  }
  function init() {
    put();
    new MutationObserver(put).observe(document.querySelector('.product__info-container') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
